import React from 'react';
import PropTypes from 'prop-types';
import history from '../../auth/history';
import Auth from '../../auth/auth';
import global from '../../stores/GlobalStore';

import DropdownPanel from '../ActivityFeed/DropdownPanel';
import './styles/UserProfile.scss';

export default class UserProfile extends React.Component {
  navToProfile = () => {
    history.push(`/u/${this.props.user.getId()}`);
  };
  navToSubmit = () => {
    history.push(`/submit`);
  };

  render() {
    const auth = new Auth();
    const user = auth.isAuthenticated()
      ? global()
          .getUserStore()
          .getUserFromLocalStorage()
      : {};

    return (
      <div className='user-profile-container'>
        <DropdownPanel
          right
          children={
            <div
              className='user-profile'
              style={{
                background: this.props.darkMode ? 'rgb(11, 19, 61)' : '',
                color: this.props.darkMode ? '#FFF' : '',
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                <a href={`/u/${this.props.user.getId()}`} onClick={this.navToProfile}>
                  View Profile
                </a>
              </div>
              <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                {user.emailConfirmed && (
                  <a href='/submit' onClick={this.navToSubmit}>
                    Submit a Show
                  </a>
                )}
              </div>
              {/*<button className='raf-button' onClick={this.props.setDarkMode}>Toggle Dark Mode</button>*/}
              <a href='/logout' onClick={this.props.logout}>
                <button className='raf-button'>Logout</button>
              </a>
            </div>
          }
        />
      </div>
    );
  }
}

UserProfile.propTypes = {
  user: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  setDarkMode: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};
